import React from 'react';

import {Filter} from 'presentation/components/Filter';
import {useNewBillsBemobiFeatureFlag} from 'presentation/pages/private/hooks/useNewBillsBemobiFeatureFlag';
import {usePaymentsHistory} from '../../hooks/usePaymentsHistory';

function FilterDateHeader() {
	const {minDate, maxDate, formattedYear} = usePaymentsHistory();
	const {isEnabled: isNewHistoryPage} = useNewBillsBemobiFeatureFlag();

	return (
		<Filter.Root $isNewHistoryPage={isNewHistoryPage}>
			<Filter.MonthYear
				viewMode="year"
				minDate={minDate}
				maxDate={maxDate}
				shouldMaxDateBeDefault
				customButtonLabel={formattedYear ? `Ano de ${formattedYear}` : undefined}
			/>
		</Filter.Root>
	);
}

export {FilterDateHeader};
